import TextError from "components/Form/TextError";
import { Seo } from "components/Seo";
import { ErrorMessage, Field, FieldArray, getIn, useFormikContext } from "formik";
//import useFormikHelper from "hooks/useFormikHelper";
import { Company, ContactPoint } from "models/Company";
import { defaultContactPointsValues } from "models/DefaultCompanyValues";
import { useEffect, useState } from "react";
import { isValidPhoneNumber } from "models/ValidationSchema"


const PhoneNumbers = () => {
  const { values, initialValues, setFieldValue } = useFormikContext<Company>();
  const [ previousIsMainId, setPreviousIsMainId ] = useState<string>(initialValues.mainContactPointId);

  const useBootstrapTooltip = (numRows: Number) => {
    useEffect(() => {
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      const tooltips = Array.from(tooltipTriggerList).map(tooltipTriggerEl => {
        return new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
      });
  
      return () => {
        tooltips.forEach(tooltip => tooltip.dispose());
      };
    }, [numRows]);
  };

  useBootstrapTooltip(values.phoneNumbers.length);


  // triggered when the current maincp becomes invalid. Reset to initial values.
  const resetMainCpId = (cp: ContactPoint, newValue: string) => {

    if (!isValidPhoneNumber(newValue) && values.mainContactPointId === cp.id) {

      if (previousIsMainId !== "") {

        setFieldValue(`mainContactPointId`, previousIsMainId);

        let previousIsMainIndex = values.phoneNumbers.findIndex(x => x.id === previousIsMainId);

        if (previousIsMainIndex !== -1) {
          setFieldValue(`phoneNumbers.[${previousIsMainIndex}].deleted`, false);
          setFieldValue(`phoneNumbers.[${previousIsMainIndex}].findability`, true);
        }
      }
    }
  }

  return (
    <><Seo title="Telefonnummer" />
      <>
       { values.phoneNumbers.length > 1 ? <div className="row g-2 align-items-center mb-5">
          <div className="col-md-3">
            <label htmlFor="isMain" className="cc-label-padding">Hovednummer</label>
            <span className="cc-help" data-bs-toggle="tooltip" data-bs-title="Hovednummeret kan ikke fjernes fra visning. For å fjerne det, vennligst endre det til et annet nummer eller kontakt kundeservice"><i className="bi bi-question-circle"></i></span>
          </div>
          <div className="col-md-3">
            <Field as="select" className="form-select" id="isMain" name="mainContactPointId" onChange={(event: { target: { value: string; }; }) => {
              let newIsMainCp: ContactPoint | undefined = values.phoneNumbers.find((x: ContactPoint) => x.id === event.target.value);
              setPreviousIsMainId(values.mainContactPointId);
              if (newIsMainCp !== undefined){
                setFieldValue(`mainContactPointId`, newIsMainCp.id);
              }
            }}>
              {
                // Check if mainContactPointId exists in phoneNumbers
                !values.phoneNumbers.some((cp: ContactPoint) => cp.id === values.mainContactPointId) && (
                  <option value="">
                    Velg hovednummer
                  </option>
                )
              }
              {
                values.phoneNumbers.map((cp: ContactPoint, index: number) => {
                  if ((!cp.deleted && cp.findability && isValidPhoneNumber(cp.value)))
                    return (<option key={index} value={cp.id}>{cp.value}</option>)
                  return null
                })
              }
            </Field>
          </div>
        </div>  : null} 


        <FieldArray name="phoneNumbers">
          {fieldArrayProps => {
            const { push, form } = fieldArrayProps;
            const { values, errors, touched } = form;
            const { phoneNumbers } = values;
            const defaultInsertValue = defaultContactPointsValues();

            defaultInsertValue.type = "Number";
            defaultInsertValue.value = "";
            
            return (
              <>
                {phoneNumbers.map((cp: ContactPoint, index: number) => {

                  return (
                    <div key={index} className="row g-2 align-items-start mb-3 cc-listing-item" >
                      
                      <div className="col-md-3">
                      <Field
                          type="number"
                          className={`form-control ${Boolean(getIn(errors, `phoneNumbers.[${index}].value`) && getIn(touched, `phoneNumbers.[${index}].value`)) && "is-invalid"}`}
                          name={`phoneNumbers.[${index}].value`}
                          placeholder="Telefonnummer"
                          inputMode="numeric"
                          pattern="[+0-9]*"
                          disabled={index <= initialValues.phoneNumbers.length - 1 || cp.type === "Telefax"}
                          value={cp.value !== null ? cp.value : ""}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => { form.setFieldValue(`phoneNumbers.[${index}].value`, event.target.value.toString()); form.setFieldValue(`phoneNumbers.[${index}].updated`, true); resetMainCpId(cp,event.target.value.toString()); }}
                          aria-label="Telefonnummer"
                          autoComplete={"nope"}
                        ></Field>
                        <ErrorMessage name={`phoneNumbers.[${index}].value`} component={TextError} />
                      </div>
                      <div className="col-md-3">
                      <span className="cc-help" data-bs-toggle="tooltip" data-bs-title='Beskrivelse av telefonnummeret, for eksempel "Kundeservice". Ikke påkrevd'>
                        <Field
                          type="text"
                          className={`form-control ${Boolean(getIn(errors, `phoneNumbers.[${index}].label`) && getIn(touched, `phoneNumbers.[${index}].label`)) && "is-invalid"}`}
                          name={`phoneNumbers.[${index}].label`}
                          placeholder={cp.type === "Telefax" ? "Telefaks" : 'Beskrivelse'}
                          value={cp.label !== null ? cp.label : ""}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => { form.setFieldValue(`phoneNumbers.[${index}].updated`, true); form.handleChange(event) }}
                          disabled={cp.type === "Telefax"}
                          aria-label="Type nummer"
                          autoComplete={"nope"}
                        ></Field>
                        </span>
                        <ErrorMessage name={`phoneNumbers.[${index}].label`} component={TextError} />
                      </div>
                      <div className="col-md-3">
                      <span className="cc-help" data-bs-toggle="tooltip" data-bs-title='Navnet som skal vises på 1881, for eksempel "Ola Nordmann". Ikke påkrevd'>
                        <Field
                          type="text"
                          className={`form-control ${Boolean(getIn(errors, `phoneNumbers.[${index}].name`) && getIn(touched, `phoneNumbers.[${index}].name`)) && "is-invalid"}`}
                          name={`phoneNumbers.[${index}].name`}
                          placeholder={cp.type === "Telefax" ? "" : "Navn"}
                          value={cp.name !== null ? cp.name : ""}
                          aria-label="Navn"
                          disabled={cp.type === "Telefax"}
                          autoComplete={"nope"}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => { form.setFieldValue(`phoneNumbers.[${index}].updated`, true); form.handleChange(event) }}
                        ></Field>
                        <ErrorMessage name={`phoneNumbers.[${index}].name`} component={TextError} />
                        <Field type="hidden" name={`phoneNumbers.[${index}].source`} value={cp.source}></Field>
                        </span>
                      </div>
                      {/* { cp.deletable === true ? (
                        
                        <>
                        <div className="col-md-3">
                          <div className="form-check form-check-inline">
                          <Field 
                          disabled={cp.id === values.mainContactPointId}
                          id={`deleteN-${index}`}
                            className="form-check-input cc-check-delete"
                            type="checkbox"
                            name={`phoneNumbers.[${index}].deleted`}
                            checked={cp.deleted === true }
                            onChange={() => { if (cp.deleted === true){
                              form.setFieldValue(`phoneNumbers.[${index}].deleted`, false);
                            }
                            else{
                              form.setFieldValue(`phoneNumbers.[${index}].deleted`, true);
                          }
                        }} />
                        <label className="form-check-label" htmlFor={`deleteN-${index}`}>Slett</label>
                          
                          </div>
                          <span className="cc-help" data-bs-toggle="tooltip" data-bs-title="Egenregistrerte nummer kan slettes fra bedriftens oppføring hos 1881"><i className="bi bi-question-circle"></i></span>
                        </div></>)
                        :

                        ( */}
                      <div className="col-md-3 mt-3">
                        <div className="form-check form-check-inline me-1">
                          <Field
                            disabled={cp.id === values.mainContactPointId}
                            id={`hideN-${index}`}
                            className="form-check-input cc-check-hide"
                            type="checkbox"
                            name={`phoneNumbers.[${index}].findability`}
                            checked={cp.findability === false}
                            autoComplete={"nope"}
                            onChange={() => {
                              if (cp.findability === true) {
                                form.setFieldValue(`phoneNumbers.[${index}].findability`, false);
                              }
                              else {
                                form.setFieldValue(`phoneNumbers.[${index}].findability`, true);
                              }
                              form.setFieldValue(`phoneNumbers.[${index}].updated`, true);
                            }} />
                          <label className="form-check-label" htmlFor={`hideN-${index}`}>Skjul</label>

                        </div>
                        {cp.id !== values.mainContactPointId && <span className="cc-help" data-bs-toggle="tooltip" data-bs-title="Nummeret skjules fra visning men vil fremdeles være søkbart hos 1881"><i className="bi bi-question-circle"></i></span>}
                        {cp.deletable && cp.id !== values.mainContactPointId ? (<div className="form-check form-check-inline ms-3 ps-0">
                          <input className="cc-check-delete d-none" type="checkbox" id={`deleteN-${index}`}></input>
                          <label className="form-check-label" htmlFor={`deleteN-${index}`}><i className="bi bi-trash3" onClick={() => {
                            if (cp.deleted === true) {
                              form.setFieldValue(`phoneNumbers.[${index}].deleted`, false);
                            }
                            else {
                              form.setFieldValue(`phoneNumbers.[${index}].deleted`, true);
                            }
                          }}> <span className="visually-hidden">Slett</span></i></label>
                        </div>)
                          : <></>
                        }
                      </div>
                    </div>
                  )
                }
                )}
                <p className="mb-3">
                  <button
                    type="button"
                    className="btn btn-light border"
                    onClick={() => {
                        let newPhoneNumber = defaultInsertValue;
  
                        if (phoneNumbers.length === 0){
                          setFieldValue(`mainContactPointId`, newPhoneNumber.id);
                        }

                        push(newPhoneNumber);
                      }
                    }
                  >
                    <i className="bi bi-plus-lg"></i> Legg til nummer
                  </button>
                </p>
              </>
            );
          }}
        </FieldArray>
      </>
    </>
  )
}

export default PhoneNumbers